module.exports = __webpack_public_path__ + "img/facebook.f21b03e7.png";